import React from "react";

import styled, { createGlobalStyle } from "styled-components";
import { MenuJumpToAnchor } from "../app/Menus/MenuJumpToAnchor";
import { ApiImage } from "../ui/ApiImage";
import { Heading } from "../ui/Heading";

const GlobalStyle = createGlobalStyle<{
  bgColor?: string;
  bgColorOn?: string;
  bgColorOff?: string;
  hlColor?: string;
}>`
  :root {
    --ikon-bg-color: ${({ bgColor }) => bgColor ?? "#fff"};
    --ikon-bg-off-color: ${({ bgColorOff }) => bgColorOff ?? "#fff"};
    --ikon-hl-color: ${({ hlColor }) => hlColor ?? "#000"};
  }
`;

const getColor = (c: any, a: number) => {
  return `rgba(
    ${c.red},
    ${c.green},
    ${c.blue},
    ${a}
    )`;
};
const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
`;

const Img = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const Screen = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.5));
`;

const PaddedContainer = styled.div<{ isTitle?: boolean }>`
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        padding: 0 ${props.theme.marginPx(breakpoint)};
        `;
    })}
  ${({ theme }) => theme.breakpoints.desktop} {
    width: ${({ isTitle }) => (isTitle ? "80%" : "100%")};
  }
  ${({ theme }) => theme.breakpoints.screen} {
    width: ${({ isTitle }) => (isTitle ? "66%" : "100%")};
  }
`;

const Grid = styled.div<{ color: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  color: ${({ color }) => color ?? "#fff"};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Nav = styled.nav<{ spaceY: number }>`
  /* overflow-y: hidden;
  overflow-x: auto;

  scrollbar-width: none;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    height: 1px;
    display: none;
  } */

  & .menuItem:last-child {
    margin-right: 0;
  }

  & a {
    color: #fff;
    text-decoration: none;
  }

  @media (any-pointer: fine) {
    & a:hover {
      color: #999;
    }
  }

  margin-top: 3px;

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        & .menuItem {
          margin-right: ${props.theme.spacePx(breakpoint, props.spaceY)};
        }
        margin-bottom: ${props.theme.spacePx(breakpoint, 8)};
        `;
    })}

  ${({ theme }) => theme.breakpoints.tablet} {
    margin-top: 0;
  }
`;

export const MicroPageIntro = ({
  data,
  menuItems,
}: {
  data: any;
  menuItems: any;
}) => {
  return (
    <>
      <GlobalStyle
        bgColor={getColor(data?.acf?.background_color, 1)}
        bgColorOff={getColor(data?.acf?.background_color, 0)}
        hlColor={getColor(data?.acf?.button_color, 1)}
      />

      <Container>
        {data?.acf?.hero_image?.sizes && (
          <Img>
            <ApiImage
              key={`microsite-intro-image`}
              aspectRatioDirection="width"
              alt=""
              sizes={data?.acf?.hero_image?.sizes}
              imgSizes="100vw"
              mode="fill"
              objectPosition={data?.acf?.hero_image?.cropPosition}
            />
          </Img>
        )}
        <Screen />
        <Grid color={getColor(data?.acf?.intro_color, 1)}>
          <PaddedContainer isTitle>
            <Heading
              heading={data?.acf?.font_style === "bold" ? "h0" : "h1"}
              fontWeight={data?.acf?.font_style === "bold" ? "700" : undefined}
              space={data?.acf?.font_style === "bold" ? 7 : 8}
              html={data?.title}
            />
          </PaddedContainer>

          {menuItems?.length > 0 && (
            <Nav spaceY={data?.acf?.font_style === "bold" ? 7 : 8}>
              <PaddedContainer>
                {menuItems.map((item: any, index: number) => {
                  return (
                    <Heading
                      className="menuItem"
                      heading={data?.acf?.font_style === "bold" ? "h2" : "h3"}
                      space={data?.acf?.font_style === "bold" ? 7 : 8}
                      fontWeight="400"
                      key={`microsite-intro-submenu-${index}`}
                      noWrap
                    >
                      <MenuJumpToAnchor
                        title={item?.title}
                        anchor={item?.anchor}
                      />
                    </Heading>
                  );
                })}
              </PaddedContainer>
            </Nav>
          )}
        </Grid>
      </Container>
    </>
  );
};

export default MicroPageIntro;
